import { Database } from 'entities/database';

export const regionNameWithInstanceCount = (region: string, databases: Database[]): string => {
  const unit = databases.length === 1 ? 'instance' : 'instances';
  return `${region} - ${databases.length} ${unit}`;
};
